import { importModal } from "../../../../redux/actions/modal";
import { importNewModal } from "../../../../redux/actions/newModal";
import { importAlertState } from "../../../../redux/actions/alert";
import { toMoney } from "../../../../utils/formatter";
import { options } from "../../../../utils/rightSideBarDetail";
import { importDisplayDetail } from "../../../../redux/actions/fcDetail";
import { importOpenSidebar } from "../../../../redux/actions/openSidebar";
import { importUpdateCashflowNeeded } from "src/redux/actions/flujocaja";
import i18n from "src/i18n";

const ABONO_CASHFLOW_ACTIONS = new Set([
  'payoff',
  'partialPayoff',
  'chequePayoff',
  'factorize',
]);

export function ActionByOption(
  dispatch,
  value,
  selected,
  cashflowAreaId,
  totalSelected,
  data,
  abonarBlocked = false,
) {
  if (abonarBlocked && ABONO_CASHFLOW_ACTIONS.has(value)) {
    dispatch(
      importAlertState({
        content: 'La función "Abonar" está bloqueada para tu cuenta.',
        state: 'warning',
        duration: 4,
      }),
    );
    return;
  }

  if (value === "payoff" && selected?.length > 0) {
    dispatch(
      importModal({
        show: true,
        content: "¿Estás seguro que deseas saldar este item?",
        title: "Saldando",
        value: selected,
        key: value,
        cashflowAreaId,
      })
    );
  } else if (value === "partialPayoff" && selected?.length > 0) {
    dispatch(
      importModal({
        show: true,
        content: "¿Estás seguro que deseas saldar parcialmente este item?",
        title: "Saldar Parcial",
        value: selected,
        key: value,
        cashflowAreaId,
      })
    );
  } else if (value === "postpone" && selected?.length > 0) {
    dispatch(
      importModal({
        show: true,
        content: "¿Estás seguro que deseas cambiar la fecha de este item?",
        title: "Cambiar Fecha",
        value: selected,
        key: value,
        cashflowAreaId,
      })
    );
  } else if (value === "revertPayoff" && selected?.length > 0) {
    dispatch(
      importModal({
        show: true,
        content: "¿Estás seguro que deseas revertir este item?",
        title: "Revertir",
        value: selected,
        key: value,
        cashflowAreaId,
      })
    );
  } else if (value === "chequePayoff" && selected?.length === 1) {
    dispatch(
      importModal({
        show: true,
        title: `¿Estás seguro que deseas saldar con cheque este item? (${toMoney(
          totalSelected?.amount
        )})`,
        value: selected,
        key: value,
        cashflowAreaId,
        amount: totalSelected?.amount,
      })
    );
  } else if (value === "chequePayoff" && selected?.length > 1) {
    dispatch(
      importAlertState({
        content: "No puede saldar más de un documento con cheques.",
        state: "error",
        duration: 3,
      })
    );
  } else if (value === "factorize" && selected?.length === 1) {
    dispatch(
      importModal({
        show: true,
        content: "¿Estás seguro que deseas factorizar este item?",
        title: "Factorizar",
        value: selected,
        key: value,
        cashflowAreaId,
        amount: totalSelected?.amount,
      })
    );
  } else if (value === "factorize" && selected?.length > 1) {
    dispatch(
      importAlertState({
        content: "No puede factorizar más de un documento a la vez.",
        state: "error",
        duration: 3,
      })
    );
  } else if (value === "revertFactorize" && selected?.length > 0) {
    dispatch(
      importModal({
        show: true,
        content:
          "¿Estás seguro que deseas revertir el factorizado de este item?",
        title: "Revertir Factorizado",
        value: selected,
        key: value,
        cashflowAreaId,
        amount: totalSelected?.amount,
      })
    );
  } else if (value === "editManual" && selected?.length > 1) {
    dispatch(
      importAlertState({
        content: "No puede editar más de un documento a la vez.",
        state: "error",
        duration: 3,
      })
    )
  } else if (value === "editManual" && selected.length === 1) {
    dispatch(
      importOpenSidebar({
        show: true,
        editManualDocument: true,
        editData: { selected, points: data },
      })
    )
  } else if (value === "fastObligation") {
    dispatch(
      importOpenSidebar({ show: true, fastObligationFC: true, editData: data })
    );

  } else if (value === "editArea") {
    dispatch(
      importOpenSidebar({ show: true, fastObligationFC: true, editData: data })
    );
  }
  else {
    dispatch(
      importAlertState({
        content: "Por favor seleccione una obligación.",
        state: "error",
        duration: 3,
      })
    );
  }
}

export function GetDropdownOptions(settledPointsView, areaName, selected, abonarBlocked = false) {
  const optionLabel = (value, fallback) =>
    i18n.t(`cashflowAreaDetail.options.${value}`, { ns: "finance", defaultValue: fallback });

  const manualOrObligation =
    selected.length > 1 || selected.length === 0
      ? false
      : selected[0].documentType !== "MANUAL" &&
        selected[0].documentType !== "OBLIGATION"
        ? false
        : true;

  // Helper to return option while dynamically switching 'Saldar' between
  // partialPayoff (single selection) and payoff (multi-selection)
  const mapWithDynamicSaldar = (option) => {
    const isSaldar = option.value === "partialPayoff";
    const isMulti = selected.length > 1;
    const dynamicValue = isSaldar && isMulti ? "payoff" : option.value;
    const dynamicText = isSaldar && isMulti
      ? optionLabel("bulkPayoff", "Saldar masivo")
      : optionLabel(option.value, option.label);
    return { key: dynamicValue, value: dynamicValue, text: dynamicText };
  };

  const option = options?.map((option) => {
    if (option.value === "editManual" && selected.length === 1 && selected[0].documentType === "OBLIGATION") {
      return mapWithDynamicSaldar(option);
    }
    else if (
      !settledPointsView &&
      areaName.name === "Clientes a crédito" &&
      option.label !== "Revertir" &&
      option.label !== "Revertir Factorizado"
    ) {
      if (manualOrObligation) {
        return mapWithDynamicSaldar(option);
      } else if (!manualOrObligation && option.value !== "editManual") {
        return mapWithDynamicSaldar(option);
      }
    } else if (
      !settledPointsView &&
      areaName.name === "Factoring" &&
      option.label !== "Revertir" &&
      option.label !== "Factorizar"
    ) {
      if (manualOrObligation) {
        return mapWithDynamicSaldar(option);
      } else if (!manualOrObligation && option.value !== "editManual") {
        return mapWithDynamicSaldar(option);
      }
    } else if (
      !settledPointsView &&
      option.label !== "Revertir" &&
      option.label !== "Factorizar" &&
      option.label !== "Revertir Factorizado"
    ) {
      if (manualOrObligation) {
        return mapWithDynamicSaldar(option);
      } else if (!manualOrObligation && option.value !== "editManual") {
        return mapWithDynamicSaldar(option);
      }
    } else if (settledPointsView && (option.label === "Revertir" || option.value === "editArea") ) {
      if (manualOrObligation) {
        return mapWithDynamicSaldar(option);
      } else if (!manualOrObligation && option.value !== "editManual") {
        return mapWithDynamicSaldar(option);
      }
    }
  });
  const onlyOptions = option?.filter((f) => f);
  if (!abonarBlocked) return onlyOptions;
  const blockedValues = new Set(['payoff', 'partialPayoff', 'chequePayoff', 'factorize']);
  return onlyOptions?.filter((o) => !blockedValues.has(o?.value));
}
